// JavaScript source code
import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { useHistory } from "react-router-dom";

const TermsAndConditionsModal = ({ studentConsent,handleAgree }) => {
    const history = useHistory();

    return (
        <div>
            <Dialog fullWidth={true}
                maxWidth={'md'}
                open={true}>
                <DialogContent>
                    <div className="completedsurvey__root" width="400px">
                        <Paper className="completedsurvey_headingHolder">
                            <CardHeader title={<span className="adventurelearn__header">Terms and Conditions Agreement</span>} />
                        </Paper>
                        <CardContent>
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                alignItems="center">
                                <Grid
                                    container
                                    direction="column"
                                    justify="space-around"
                                    alignItems="center">
                                    <Typography className="adventurelearn__subheader">
                                        Welcome to AdventureLearn, your SIT survival kit!
                                    </Typography>
                                    <Typography className="adventurelearn__tandcContent">
                                        Here, you'll get to know yourself better, receive personalised resource recommendations, and earn rewards as you go along-all while helping SIT optimise your learning environment to boost your learning!
                                    </Typography>
                                    <Typography className="adventurelearn__tandcContent">
                                        By using AdventureLearn, you agree to the collection and use of your platform usage data for research and platform improvement purposes.These may include information such as the duration spent on the platform, the number of resources accessed, and other statistics.
                                    </Typography>
                                    <Typography className="adventurelearn__tandcContent">
                                    Faculty may have access to your data in order to design and implement teaching and learning including coaching, to better meet your needs and support you in your pursuit to being an effective learner.
                                    </Typography>
                                    <Typography className="adventurelearn__tandcContent">
                                        Should you have any questions, please contact us at adventurelearn@singaporetech.edu.sg.
                                    </Typography>
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    justify="space-evenly"
                                    alignItems="flex-start">
                                    <Button variant={'outlined'} onClick={() => handleAgree()} className="adventurelearn__dialogOk">
                                        Agree
                                    </Button>
                                </Grid>

                            </Grid>
                        </CardContent>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export { TermsAndConditionsModal as default }